"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const stories = [{
  id: 1,
  title: "Podcast Corporativo Tech",
  category: "Podcast Profissional",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/podcast_studio_pinheiros_main.png",
  ratio: 16 / 9,
  span: "md:col-span-7",
  description: "Produção completa de série de podcasts para autoridade em tecnologia, com captação 4K e edição dinâmica focada em retenção e conversão de leads B2B."
}, {
  id: 2,
  title: "Campanha Institucional",
  category: "Vídeo Estratégico",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/portfolio_video_institucional.png",
  ratio: 4 / 5,
  span: "md:col-span-5",
  description: "Vídeo de posicionamento de marca para empresa do setor financeiro na Faria Lima, utilizando estética moderna e narrativa de alto impacto visual."
}, {
  id: 3,
  title: "Estratégia de Tráfego",
  category: "Performance & Ads",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/portfolio_trafego_pago.png",
  ratio: 4 / 5,
  span: "md:col-span-5",
  description: "Gestão de anúncios em vídeo para escala de vendas, integrando criativos de alta conversão produzidos em nosso estúdio com segmentação precisa."
}, {
  id: 4,
  title: "Série Expert Talks",
  category: "Estúdio Pinheiros",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/pinheiros_studio_interior.png",
  ratio: 16 / 9,
  span: "md:col-span-7",
  description: "Gravação de videocast em ambiente controlado com iluminação cênica e tratamento acústico premium, elevando o patamar de autoridade do cliente."
}];
export default function ImpactStories() {
  return <section data-section-id="223734" id="projetos-para-empresas-que-buscam-posicionamento-e-crescimento" className="dark bg-background text-foreground section px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <h2 className="text-4xl font-default font-bold tracking-tight mb-6 uppercase text-secondary-foreground ![padding:0px_4px_0px_4px] md:text-6xl">Projetos de vídeo, podcast e tráfego para empresas em São Paulo</h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">Veja como aplicamos estratégia, produção e mídia para gerar posicionamento e clientes.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {stories.map((story, i) => <div key={story.id} data-index={i} className={story.span}>
              <Dialog>
                <DialogTrigger className="w-full h-full text-left outline-none group block relative overflow-hidden bg-muted rounded-lg shadow-lg">
                  <AspectRatio ratio={story.ratio} className="w-full h-full">
                    <img src={story.image} alt={story.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 flex items-end justify-start opacity-0 group-hover:opacity-100 transition-all duration-500 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent backdrop-blur-[2px]">
                      <div className="p-8 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                        <span className="text-primary-foreground font-mono text-xs md:text-sm uppercase tracking-widest mb-2 block opacity-90">
                          {story.category}
                        </span>
                        <h3 className="text-2xl md:text-4xl font-default font-bold text-primary-foreground tracking-tight">
                          {story.title}
                        </h3>
                      </div>
                    </div>
                  </AspectRatio>
                </DialogTrigger>
                <DialogContent className="max-w-5xl p-0 overflow-hidden border-border bg-card rounded-none gap-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full max-h-[90vh] overflow-y-auto md:overflow-hidden">
                    <div className="relative h-64 md:h-full min-h-[300px]">
                      <img src={story.image} alt={story.title} className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <div className="p-8 md:p-16 flex flex-col justify-center bg-card">
                      <span className="text-primary font-mono text-sm uppercase tracking-widest mb-6 block">
                        {story.category}
                      </span>
                      <DialogTitle className="text-3xl md:text-5xl font-default font-bold mb-6 tracking-tight text-foreground">
                        {story.title}
                      </DialogTitle>
                      <DialogDescription className="text-muted-foreground text-base md:text-lg mb-10 leading-relaxed font-default">
                        {story.description}
                      </DialogDescription>
                      <Button asChild size="lg" className="w-fit rounded-full bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-wider font-semibold group shadow-md">
                        <Link to="#">
                          Ver Case Completo
                          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}